<template>
  <section class="news" v-if="this.posts.count != 0">
    <div class="container">
      <h2><span>Últimas</span> notícias</h2>
      <router-link :to="{ name: 'Blog' }" class="view-more" exact>
        Ver todas
        <img alt="Icon arrow left" src="~@/assets/icons/arrow-left.svg"
      /></router-link>
    </div>
    <div class="container container-news">
      <div
        class="box-news"
        v-for="item in this.posts"
        :value="item.id"
        :key="item.id"
      >
        <router-link
          :to="{
            name: 'BlogPost',
            params: { slug: item.attributes.slug }
          }"
          exact
        >
          <img class="news-image" alt="" :src="item.attributes.banner_url" />
        </router-link>
        <router-link
          :to="{
            name: 'BlogPost',
            params: { slug: item.attributes.slug }
          }"
          exact
        >
          <h3>{{ item.attributes.title }}</h3>
        </router-link>
        <p>{{ item.attributes.description }}</p>
        <router-link
          :to="{
            name: 'BlogPost',
            params: { slug: item.attributes.slug }
          }"
          exact
        >
          Ler mais
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import { blogService } from "@/services/blog.service";

export default {
  name: "News",

  data() {
    return {
      posts: []
    };
  },

  mounted() {
    this.getPosts();
  },

  methods: {
    async getPosts() {
      try {
        const params = {
          items: 3,
          page: 1
        };
        const posts = await blogService.listPosts(params);
        this.posts = posts.data.data.slice(0, 3);
      } catch (error) {
        console.log("Ocorreu um erro inesperado.");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.news {
  padding: 130px 0 130px;
  background-color: var(--blue-custom);

  .container {
    display: flex;
    justify-content: space-between;
    max-width: 1200px;
    align-items: flex-start;

    &.container-news {
      max-width: 1200px;
      margin-top: 62px;
    }

    a {
      color: #ffffff;
    }
  }

  h2 {
    font-size: var(--size-h2);
    line-height: 48px;
    color: var(--white);
    font-weight: 700;

    span {
      font-weight: 300;
      line-height: 32px;
    }
  }

  .view-more {
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 300;
    color: var(--blue-custom);
    font-size: var(--size-h4);
    text-decoration: none;

    img {
      margin-left: 16px;
    }
  }

  .box-news {
    max-width: 380px;
    width: 100%;
    padding: 0 10px 0 10px;

    img {
      width: 100%;
      height: auto;
      margin-bottom: 30px;
      border-radius: 30px;
      height: 254px;
      object-fit: cover;
    }

    h3 {
      min-height: 48px;
      margin-bottom: 16px;
      font-weight: 700;
      line-height: 29px;
      font-size: var(--size-large);
      color: var(--white);
    }

    p {
      max-width: 320px;
      font-weight: 300;
      line-height: 29px;
      font-size: var(--size-large);
      color: var(--light-grey);
      margin-bottom: 32px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 4;
      -webkit-box-orient: vertical;
    }

    a {
      text-decoration: none;
      color: var(--white);
      font-weight: 400;
    }
  }

  @media (max-width: 768px) {
    padding: 60px 0 60px;

    .container {
      align-items: flex-start;
      flex-direction: column;

      &.container-news {
        margin-top: 32px;
      }
    }

    .box-news {
      margin-bottom: 32px;

      &:last-child {
        margin-bottom: 0px;
      }

      p {
        margin-bottom: 16px;
      }
    }
  }
}
</style>
